import { observer } from 'mobx-react-lite';
import React, { FC } from 'react';

const DistanceTeacherParticipant: FC = () => {

    return (
        <div>
            <h5>DistanceTeacherParticipant</h5>
        </div>
    )
};
export default observer(DistanceTeacherParticipant);